var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGym = function SvgGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.196 21.196"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m11.601 6.6-5.001 5m8.002-2L9.6 14.602m-7.167.16-1.294 1.295a1.84 1.84 0 0 0 0 2.602l1.398 1.398a1.84 1.84 0 0 0 2.602 0l1.294-1.294m8.33-16.33 1.294-1.294a1.84 1.84 0 0 1 2.602 0l1.398 1.398a1.84 1.84 0 0 1 0 2.602l-1.294 1.294M11.2 1.701l-.835.835a2 2 0 0 0 0 2.83l5.47 5.469a2 2 0 0 0 2.83 0L19.5 10a2 2 0 0 0 0-2.83l-5.47-5.469a2 2 0 0 0-2.828 0m-9.5 9.5.835-.835a2 2 0 0 1 2.83 0l5.469 5.47a2 2 0 0 1 0 2.83L10 19.5a2 2 0 0 1-2.83 0l-5.469-5.47a2 2 0 0 1 0-2.828"
  })));
};
export default SvgGym;